import RestoreIcon from "@mui/icons-material/Restore";
import SensorsOffIcon from "@mui/icons-material/SensorsOff";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
import VideoPlayer from "../Common/VideoPlayer";
export interface IDisconnectNetwork {
  displayNextSlide: () => void;
  type?: number;
  consoleImg?: boolean;
}

const DisconnectNetwork = (props: IDisconnectNetwork) => {
  const classes = useStyles();
  const [nextSlide, showNextSlide] = React.useState(0);

  const disconnectClick = () => {
    showNextSlide(nextSlide + 1);
    props.displayNextSlide();
  };

  return (
    <Box
      className={classes.positionComponent}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      {props?.consoleImg && (
        <VideoPlayer
          videoURL={"asset/video/ScanningProgressVideo.mp4"}
          displayNextSlide={() => {}}
          styles={{
            position: "absolute",
            left: "5%",
            top: "11%",
            marginTop: "3rem",
            height: "20%",
            width: "40%",
          }}
        />
      )}
      <DialogBox
        childProps={
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "inherit",
              width: "inherit",
            }}
          >
            {props?.type === 1 ? <RestoreIcon /> : <SensorsOffIcon />}
            <Typography
              variant="body2"
              color="white"
              sx={{ fontWeight: "600", padding: "0.5rem 1rem 0.5rem 1rem" }}
            >
              {props?.type === 1
                ? "Restore backups? "
                : "Disconnect from outside network?"}
            </Typography>
            <Button
              sx={{
                borderRadius: "3rem",
                textTransform: "capitalize",
                padding: "0.5rem 1.5rem",
                fontSize: "1rem",
                fontWeight: "600",
                backgroundColor: "#56CCF2",
                width: "70%",
                color: "#004D66",
              }}
              variant="contained"
              onClick={disconnectClick}
            >
              {props?.type === 1 ? "Restore" : "Disconnect "}
            </Button>
            <Typography
              variant="subtitle1"
              color="#56CCF2"
              sx={{ fontWeight: "500" }}
            >
              {props?.type === 1 ? "Cancel" : "Leave network connected"}
            </Typography>
          </div>
        }
        type={1}
      />
    </Box>
  );
};

export default DisconnectNetwork;
